import { API_BASE, API_URL, APPLICATION_JSON_HEADER } from "@/constants";
import { NewsletterSignUpData } from "@/types/api/newsletter-signup";
import { SuccessResponse } from "@/types/api/shared";
import { getApiError } from "@/utils/api-error";

export async function postNewsletterSignUp(body: NewsletterSignUpData) {
  const response = await fetch(`${API_URL}${API_BASE}/newsletter-sign-up`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      ...APPLICATION_JSON_HEADER,
    },
  });
  if (!response.ok) {
    throw await getApiError(response);
  }
  return response.json() as Promise<SuccessResponse>;
}
